<template>
    <Card :header="$t('filters')">

        <b-form-group :label="$t('code')" label-cols-sm="3">
            <b-form-input v-model="parentComponent.filters.code" :disabled="loading" />
        </b-form-group>


        <b-form-group :label="$t('name')" label-cols-sm="3">
            <b-form-input v-model="parentComponent.filters.name" :disabled="loading" />
        </b-form-group>


        <b-form-group :label="$t('city')" label-cols-sm="3">
            <b-form-input v-model="parentComponent.filters.city" :disabled="loading" />
        </b-form-group>


        <b-form-group :label="$t('postcode')" label-cols-sm="3">
            <b-form-input v-model="parentComponent.filters.zip" :disabled="loading" />
        </b-form-group>


        <b-form-group :label="$t('address')" label-cols-sm="3">
            <b-form-input v-model="parentComponent.filters.address" :disabled="loading" />
        </b-form-group>

        <b-form-group :label="$t('hidden')" label-cols-sm="3">
            <b-form-checkbox-group v-model="parentComponent.filters.hide" :options="hideOptions" :disabled="loading" class="h-100 d-flex align-items-center" />
        </b-form-group>

        <div class="d-flex gap-3">
            <ButtonIcon :disabled="parentComponent.loading" @click="parentComponent.filterData()">
                {{ $t('filter') }}
            </ButtonIcon>
            <ButtonIcon variant="light" :disabled="parentComponent.loading" @click="parentComponent.resetData()">
                {{ $t('reset') }}
            </ButtonIcon>
        </div>
    </Card>
</template>



<script>
    export default {
        name: 'Filters',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        computed: {
            loading() {
                return this.parentComponent.loading;
            },
            hideOptions() {
                return [
                    { value: 1, text: this.$t('yes') },
                    { value: 0, text: this.$t('no') },
                ];
            },
        },
    };
</script>
